import { FormEntry } from "components";

export const LastPage = ({ register, errors, studentPrefix, setStudentPrefix, watch, control }) => {
	return (
		<>
			<FormEntry formLabel="Teachers Remark" type="text" name="teachersRemark" register={register} error={errors.teachersRemark} />
		</>
	);
};
